
import { YoungQuestion } from '@/types/personality';

// Questions for Disconnection & Rejection Domain
export const disconnectionQuestions: YoungQuestion[] = [
  // Esquema: Privação Emocional
  {
    id: 1,
    text: "A maior parte do tempo, não tive ninguém para me nutrir, compartilhar comigo ou se importar profundamente com tudo que me acontecia.",
    domain: "disconnection",
    schema: "emotional_deprivation"
  },
  {
    id: 2,
    text: "Em geral, não tive pessoas para me dar calor, segurança e afeto.",
    domain: "disconnection",
    schema: "emotional_deprivation"
  },
  {
    id: 3,
    text: "Por muito tempo na minha vida, não me senti especial para ninguém.",
    domain: "disconnection",
    schema: "emotional_deprivation"
  },
  
  // Esquema: Abandono
  {
    id: 4,
    text: "Frequentemente, me preocupo que as pessoas que amo possam me abandonar ou me deixar.",
    domain: "disconnection",
    schema: "abandonment"
  },
  {
    id: 5,
    text: "Sinto que as pessoas de quem preciso, acabarão me deixando.",
    domain: "disconnection",
    schema: "abandonment"
  },
  {
    id: 6,
    text: "Quando sinto que alguém que me importo está se afastando, fico desesperado.",
    domain: "disconnection",
    schema: "abandonment"
  },
  
  // Esquema: Desconfiança/Abuso
  {
    id: 7,
    text: "Sinto que as pessoas irão tirar vantagem de mim.",
    domain: "disconnection",
    schema: "mistrust_abuse"
  },
  {
    id: 8,
    text: "Sinto que não posso baixar minha guarda na presença de outras pessoas, senão elas deliberadamente me magoarão.",
    domain: "disconnection",
    schema: "mistrust_abuse"
  },
  {
    id: 9,
    text: "É apenas uma questão de tempo até as pessoas me traírem.",
    domain: "disconnection",
    schema: "mistrust_abuse"
  },
  
  // Esquema: Isolamento Social
  {
    id: 10,
    text: "Não me sinto pertencendo a nenhum grupo; sou um solitário.",
    domain: "disconnection",
    schema: "social_isolation"
  },
  {
    id: 11,
    text: "Sou fundamentalmente diferente das outras pessoas.",
    domain: "disconnection",
    schema: "social_isolation"
  },
  {
    id: 12,
    text: "Não me encaixo; sou diferente da maioria das pessoas.",
    domain: "disconnection",
    schema: "social_isolation"
  },
  
  // Esquema: Defectividade/Vergonha
  {
    id: 13,
    text: "Ninguém que eu desejo, iria querer ficar comigo se me conhecesse realmente.",
    domain: "disconnection",
    schema: "defectiveness"
  },
  {
    id: 14,
    text: "Sou indigno do amor, atenção e respeito dos outros.",
    domain: "disconnection",
    schema: "defectiveness"
  },
  {
    id: 15,
    text: "Sinto que não sou amável.",
    domain: "disconnection",
    schema: "defectiveness"
  }
];
